import { nuxKeyFor } from './adKeys';

// Async because a rule may have to ask the server. Ordering is unchanged: first
// match wins, and an ad whose rule says no falls through to the next one.

export const selectAd = async (registry, ctx, { seenNux }) => {
  if (!ctx.isLDidentified || !ctx.diffitUser) return null;

  // Sequential on purpose: an ad's rule is only asked once every ad above it has
  // declined, so a rule that costs a round trip never runs for a slot already won.
  for (const ad of registry) {
    if (seenNux?.[nuxKeyFor(ad.id)]?.dismissed) continue;
    if (await ad.eligible(ctx)) return ad;
  }
  return null;
};
